import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useEffect } from 'react';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
class worldPageStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  // 是否激活
  @observable isActive = false;
  // page7数据
  @observable page7Data;

  @observable worldViewList;

  worldViewSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      observe: true,
      observeParents: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      on: {
        touchMove(e) {
          if (e.target.className === 'text') {
            e.stopPropagation();
          }
        },
        touchStart(e) {
          if (e.target.className === 'text') {
            e.stopPropagation();
          }
        }
      }
    }
  });
  use() {
    const Part7Date = useLayerData('worldPageData');

    useEffect(
      () => {
        if (!Part7Date) {
          return;
        }
        this.page7Data = Part7Date;
        //console.log(Part7Date, 'featureListfeatureList', this.page7Data);
        this.worldViewList = Part7Date.word_view_list;
        //console.log('worldViewList', this.worldViewList);
        this.featureList = Part7Date.featureList;
      },
      [Part7Date]
    );
  }
}

export default worldPageStore;
